import { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck } from '@fortawesome/free-solid-svg-icons';
import { AnswerType } from '../enums/AnswerType';

export default function AddedCover(props: any) {
    const [question] = useState(props.question);

    if (question.questionSetQuestion.visible && props.question.questionSetQuestion.enabled && question.page === props.page) {
        const isRadioType = question.questionSetQuestion.answerTypeID === AnswerType.Radio;
        const isListBoxType = question.questionSetQuestion.answerTypeID === AnswerType.ListBox;

        if (
            (props.question.sectionName.toLowerCase() === "tools and materials cover" ||
                props.question.sectionName.toLowerCase() === "customise your cover" ||
                props.question.sectionName.toLowerCase() === "cover essentials" ||
                props.question.sectionName.toLowerCase() === "cover required")
            && props.question.enablementCriteria.length == 0) {

            if (isRadioType || isListBoxType) {

                let addedCoverText = "Temporary employees insurance";

                if (question.questionSetQuestion.text.includes("Cover")) {
                    addedCoverText = question.questionSetQuestion.text.includes("Cover")
                        ? question.questionSetQuestion.text.split("Cover")[0] + "Cover"
                        : question.questionSetQuestion.text;
                }

                if (question.questionSetQuestion.text.includes("cover")) {
                    addedCoverText = question.questionSetQuestion.text.includes("cover")
                        ? question.questionSetQuestion.text.replace(/^Do you require cover for\s/, '').replace(/\?/, '')
                        : question.questionSetQuestion.text;
                    addedCoverText = addedCoverText.charAt(0).toUpperCase() + addedCoverText.slice(1);
                }

                if (isListBoxType) {
                    let dropdownItem = question.answerList.filter((x: { value: any; }) => x.value === question.answer);
                    addedCoverText = dropdownItem[0].text;
                }

                return (
                    <>
                        {((question.answer === "1" && isRadioType) || isListBoxType) && (
                            <p>
                                <span className="sidebar-component-container cover-requirements">
                                    <span>
                                        <FontAwesomeIcon className="tick-icon" icon={faCircleCheck} />
                                        {isRadioType ? (
                                            addedCoverText
                                        ) : (
                                            <>Public Liability - {addedCoverText}</>
                                        )}
                                    </span>
                                </span>
                            </p>
                        )}
                    </>
                );
            }
        }
    }
    if (question.questionSetQuestion.text.toLowerCase() === "total number of employees") {
        if (question.answer > 0) {
            return (
                <>
                    <p>
                        <span className="sidebar-component-container cover-requirements">
                            <span>
                                <FontAwesomeIcon className="tick-icon" icon={faCircleCheck} />
                                <>Employers Liability - &pound;10,000,000</>
                            </span>
                        </span>
                    </p>
                </>
            );
        }
    }

    return null;
}